<div
  class="col-sm-12 d-flex justify-content-between ptb-6 mb-8"
  [ngClass]="{ ar: lang == 'ar', en: lang == 'en' }"
>
  <div class="w-100">
    <div
      class="w-100 shadow-none position-relative"
      [ngClass]="{ 'pr-22': lang == 'ar', 'pl-22': lang == 'en' }"
    >
      <!-- Accordion container with dynamic ID to ensure uniqueness -->
      <div
        class="accordion accordion-flush position-relative"
        id="accordionFlushExample{{ item.id }}"
      >
        <div class="accordion-item">
          <!-- Accordion header with dynamic ID -->
          <h2 class="accordion-header" id="flush-headingOne+{{ item.id }}">
            <!-- Accordion button to control collapse, with dynamic target and aria attributes  && Ensures unique target ID -->
            <!-- Links to the content ID below -->
            <button
              class="accordion-button collapsed shadow-sm d-flex justify-content-between align-items-center w-100 ptb-16 border-radius-8"
              [ngClass]="{
                'accordion-button':
                  item.levelEnum == AccountLevel.MainAccount || ForeginMain,
                'accordion-button-arrow':
                  item.levelEnum == AccountLevel.SubAccount || !ForeginMain
              }"
              type="button"
              data-bs-toggle="collapse"
              attr.data-bs-target="#A{{ item.id }}"
              aria-expanded="false"
              attr.aria-controls="A{{ item.id }}"
            >
              <!-- Display item name and optional level indicator -->
              <a
                class="w-content mb-0 px-2 position-relative"
                *ngIf="!item.children?.length"
                [routerLink]="
                  routeringPath != null ? [routeringPath, item.id] : null
                "
              >
                <span [innerHTML]="iconInput"></span>{{ item?.code}} {{ item.name }}
              </a>
              <p
                class="w-content mb-0 px-2 position-relative"
                *ngIf="item.children?.length"
              >
                <span [innerHTML]="iconInput"></span>{{ item?.code}} {{ item.name }}
                <!-- Conditional badge -->
              </p>

              <!-- Icons for add, edit, and delete functionalities -->
              <div class="d-flex w-content px-2 icons">
                <!-- not that the design is handled as only the main item or forign-main items have add-button and other has edit or delete -->
                <span
                  [innerHTML]="icons.iconAdd"
                  (click)="openAdd(item.id)"
                  *ngIf="viewAddButton"
                ></span>
                <!-- Add icon -->
                <span
                  [innerHTML]="icons.iconEdit"
                  class="pointer"
                  *ngIf="viewEditButton"
                  (click)="editItem(item)"
                ></span>
                <!-- Edit icon -->
                <span
                  [innerHTML]="icons.iconDelete"
                  *ngIf="viewDeleteButton"
                  (click)="deleteItem(item)"
                ></span>
                <!-- Delete icon -->
              </div>
              <span
                class="primary-card"
                *ngIf="
                  item.levelEnum == AccountLevel.MainAccount ||
                  ForeginMain ||
                  isMain
                "
              ></span>
            </button>
          </h2>

          <!-- Arrow icon for non-super-main items -->
          <span *ngIf="isMain != null">
            <span class="arrow" *ngIf="!isMain"></span>
          </span>
          <span *ngIf="ForeginMain != null">
            <span class="arrow" *ngIf="!ForeginMain"></span>
          </span>

          <!-- Accordion content with dynamic ID and aria attributes  with  id Links back to header-->
          <div
            id="A{{ item.id }}"
            class="accordion-collapse collapse"
            attr.aria-labelledby="flush-headingOne+{{ item.id }}"
            attr.data-bs-parent="#accordionFlushExample{{ item.id }}"
          >
            <!-- Ensures this accordion is part of the parent group -->
            <div class="accordion-body">
              <!-- Recursively render child items using app-shared-accordion component -->
              <div *ngIf="item.children">

                <app-shared-accordion
                  *ngFor="let temp of item.children"
                  (editItemEvent)="editItem($event)"
                  (deleteItemEvent)="deleteItem($event)"
                  (getData)="getDataFun()"
                  [item]="temp"
                  [isMain]="temp.children?.length>0"
                  [ForeginMain]="null"
                  [viewEditButton]="viewEditButton"
                  [viewDeleteButton]="viewDeleteButton"
                  [routeringPath]="routeringPath"
                >
                </app-shared-accordion>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Additional styling for non-main items -->
      <span class="col-gray" *ngIf="isMain == false"></span>
      <span class="col-gray" *ngIf="ForeginMain == false"></span>
    </div>
  </div>
</div>
